export default __webpack_public_path__ + "static/media/login_bg.8c18e4e5.svg";